var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubmission(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sub_BTN",
    transform: "translate(-12.000000, -8.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(13.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.09886957,13.589913 C1.45365217,13.589913 0.885826087,13.162087 0.708434783,12.542087 C0.530173913,11.922087 0.784956522,11.2586087 1.33191304,10.9168696 L17.404087,0.872521739 C17.8910435,0.567304348 18.511913,0.580347826 18.9858261,0.903826087 C19.4597391,1.22730435 19.698,1.80121739 19.591913,2.36556522 L16.4658261,19.0377391 C16.3606087,19.6012174 15.931913,20.0490435 15.3727826,20.1794783 C14.8145217,20.309913 14.231913,20.0977391 13.8875652,19.6386087 L9.35104348,13.589913 L2.09886957,13.589913 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.35086957,13.589913 L7.18130435,13.589913 L7.18130435,18.0855652 C7.18130435,18.622087 7.47782609,19.1142609 7.95173913,19.3646957 C8.42565217,19.6151304 8.99956522,19.5829565 9.44217391,19.2812174 L12.2056522,17.3968696 L9.35086957,13.589913 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.35086957,13.589913 L18.9856522,0.903826087",
    id: "Stroke-5"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmission);
export default __webpack_public_path__ + "static/media/submission.6844082cc61781c39253d2ff43101984.svg";
export { ForwardRef as ReactComponent };